import BudgetsKanban from "../../../components/budgetsKanban";

const BudgetsKanbanPage = (props: any) => {
  return <BudgetsKanban persona="MANAGER" {...props} />;
};

export default BudgetsKanbanPage;
